export const BASE_ROUTES = {
  HOME: 'home',
  EVENT_HUB: 'event-hub',
  PLAYER: 'player',
  SEARCH: 'search',
  SPORT_FILTER: 'sport-filter',
  EDIT_FAVORITES: 'edit-favorites',
  FAVORITE_HUB: 'favorite-hub',
  COLLECTION: 'collection',
  NAV_HUB: 'nav-hub',
}

export const SPLASH = 'splash'
export const FIRST_LANDING = 'firstlanding'
export const LANDING = 'landing'
export const HOME = BASE_ROUTES.HOME
export const VERTICAL_HOME = `${BASE_ROUTES.HOME}/:siteId`
export const NAV_HUB = `${BASE_ROUTES.NAV_HUB}/:siteId/:navId`
export const PAYWALL = 'paywall'
export const PLAYER = `${BASE_ROUTES.PLAYER}/:id`
export const EVENT_HUB = `${BASE_ROUTES.EVENT_HUB}/:url?`
export const SIGN_UP = 'signup'
export const SPORTS = 'sports'
export const LOGIN = 'login'
export const FORGOT_PASSWORD = 'forgotpassword'
export const COLLECTION = `${BASE_ROUTES.COLLECTION}/:url`
export const SPORT_FILTER = `${BASE_ROUTES.SPORT_FILTER}/:url?`
export const SEARCH = `${BASE_ROUTES.SEARCH}/:url?`
export const EDIT_FAVORITES = `${BASE_ROUTES.EDIT_FAVORITES}/:url?`
export const ADD_FAVORITES_SPORT_PICKER = `${BASE_ROUTES.EDIT_FAVORITES}/sports/:action/:url`
export const ADD_FAVORITES_ENTITY_SEARCH = `${BASE_ROUTES.EDIT_FAVORITES}/add-favorite/:url`
export const SETTINGS = 'settings'
export const ACCOUNT_DETAILS = 'account-details'
export const SUBSCRIPTION = 'subscription'
export const LIVE_SCORES = 'live-scores'
export const CUSTOMER_SUPPORT = 'customer-support'
export const TERMS_OF_SERVICE = 'terms-of-service'
export const PRIVACY_POLICY = 'privacy-policy'
export const DEVELOPER_SETTINGS = 'developer-settings'
export const FAVORITE_HUB = `${BASE_ROUTES.FAVORITE_HUB}/:url?`
export const LG_SIGN_UP = 'lg-sign-up'
export const VIZIO_SIGN_UP = 'vizio-sign-up'
// Special routes
export const NOT_FOUND = '*'
export const ERROR = '!'
export const BOOT = '$'
